import { CollegeBanner } from "./CollegeBanner";
import { CollegeHighlights } from "./CollegeHighlights";
import { CostEstimator } from "./CostEstimator";
import { RankingsOutcomes } from "./RankingsOutcomes";
import { StudentTools } from "./StudentTools";
import { InteractiveMap } from "./InteractiveMap";
import { StudentReviews } from "./StudentReviews";
import "./CollegeProfile.css";

export const CollegeProfile = ({ data }) => {
  if (!data) return null;

  return (
    <div className="college-profile-container">
      <CollegeBanner data={data} />
      <CollegeHighlights data={data} />
      <CostEstimator data={data} />
      <RankingsOutcomes data={data} />
      <StudentTools />
      <InteractiveMap data={data} />
      <StudentReviews data={data} />
    </div>
  );
};
